import ChargePointCard from './ChargePointCard'

export default ChargePointCard
